import { createContext, useContext } from "react";

import type { ComboboxProps } from "./Combobox.types";

export type ComboboxContextValue = Pick<ComboboxProps, "size">;

export function makeComboboxContext({
  size = "md",
}: Partial<ComboboxContextValue>): Required<ComboboxContextValue> {
  return { size };
}

export const ComboboxContext = createContext<Required<ComboboxContextValue>>(
  makeComboboxContext({}),
);

export function useComboboxContext() {
  return useContext(ComboboxContext);
}
